/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TestDetectionRuleMatch = {
  /**
   * Confidence score in the range 0.0 to 1.0.
   */
  confidence: number;
  /**
   * Human-readable description of why this match was flagged.
   */
  description?: string | undefined;
  /**
   * Exclusive end byte offset of the match in the sample.
   */
  endPos: number;
  /**
   * Matched substring of the sample.
   */
  match: string;
  /**
   * Canonical rule id of the match (may differ from the requested rule id when one input matches multiple rules).
   */
  ruleId: string;
  /**
   * Detection source (e.g. `gitleaks`, `presidio`, `prompt_injection`, `custom`).
   */
  source: string;
  /**
   * Inclusive start byte offset of the match in the sample.
   */
  startPos: number;
  /**
   * Tags from the underlying rule.
   */
  tags?: Array<string> | undefined;
};

/** @internal */
export const TestDetectionRuleMatch$inboundSchema: z.ZodMiniType<
  TestDetectionRuleMatch,
  unknown
> = z.pipe(
  z.object({
    confidence: z.number(),
    description: z.optional(z.string()),
    end_pos: z.int(),
    match: z.string(),
    rule_id: z.string(),
    source: z.string(),
    start_pos: z.int(),
    tags: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "end_pos": "endPos",
      "rule_id": "ruleId",
      "start_pos": "startPos",
    });
  }),
);

export function testDetectionRuleMatchFromJSON(
  jsonString: string,
): SafeParseResult<TestDetectionRuleMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TestDetectionRuleMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TestDetectionRuleMatch' from JSON`,
  );
}
